import api from "../../../../lib/api";
import { IHubCreate, IHubListSearch, IEditHubPayload } from "../../../../types/master/hubInterface";

export const createHubApi = async (data: IHubCreate) => {
  return await api.post(`/hub`, data);
};

export const getHubListApi = async (data: IHubListSearch) => {
  return await api.get(`/hub/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getHubDataByIdApi = async (id: number) => {
  return await api.get(`/hub/${id}`)
}

export const editHubDataByIdApi = async (payload: IEditHubPayload) => {
  return await api.put(`/hub/${payload.id}`, payload.data);
};